import { useState, useEffect } from 'react';
import Adesao from "./Engajamento/Adesao";
import Acesso from "./Engajamento/Acesso";
import AlunoResponsavelAtivo from './AlunoResponsavel/AlunoResponsavelAtivo';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { currentUser } from './Usuario/api-usuario';
import { setUsuario as setUsuarioRedux } from './Usuario/actions/actions';
import { useDispatch } from 'react-redux';
import MuralUsuarioContainer from './Mural/MuralUsuario/MuralUsuarioContainer';
import { ADMIN, COORDENADOR, perfilText, PROFESSOR, SECRETARIA } from './Usuario/Perfil';
import { errorMessage } from '../util/ConfirmAlertUtil';
import { Button, Divider, Grid } from '@mui/material';
import TarefaContainer from './Tarefa/TarefaContainer';
import { splitUtil } from '../util/StringUtil';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
        marginBottom: '20px'
    },
    bold: {
        fontWeight: 'bold'
    },
    componentExternal: {
        marginBottom: '20px'
    }
});

export default function Home() {
    const classes = useStyles();
    const [usuario, setUsuario] = useState();
    const dispatch = useDispatch();
    const adesaoAcessoKey = 'adesao-acesso';
    const tarefaKey = 'tarefa';
    const [menu, setMenu] = useState(tarefaKey);

    useEffect(() => {
        currentUser().then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setUsuario(data);
                    dispatch(setUsuarioRedux(data));
                    document.title = data.instituicao.descricao
                }
            }

        })
    }, [dispatch])


    return (
        <div>
            <Container className={classes.paper} component={Paper}>
                <Typography className={classes.bold} variant="body1">
                    Seja Bem Vindo
                </Typography>
                <Typography variant="body1">
                    <span className={classes.bold}>Usuário:</span> {usuario ? splitUtil(usuario.nome, " ", 2) : ''}
                </Typography>
                <Typography variant="body1">
                    <span className={classes.bold}>Perfil:</span> {usuario ? perfilText(usuario.perfil) : ''}
                </Typography>
            </Container>
            {usuario &&
                (usuario.perfil === ADMIN ||
                    usuario.perfil === COORDENADOR ||
                    usuario.perfil === SECRETARIA ||
                    usuario.perfil === PROFESSOR) ?
                <Container className={classes.paper} component={Paper}>

                    <Grid container spacing={3} direction='column'>
                        <Grid>
                            <Grid container spacing={3} direction='row'>
                                <Grid>
                                    <Button
                                        onClick={() => setMenu(tarefaKey)}
                                        variant='outlined'
                                    >
                                        Tarefa
                                    </Button>
                                </Grid>
                                <Grid>
                                    <Button
                                        onClick={() => setMenu(adesaoAcessoKey)}
                                        variant='outlined'
                                    >
                                        Adesão/Acesso
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid>
                            <Divider />
                        </Grid>
                        {menu === adesaoAcessoKey ?
                            <>
                                <Grid>
                                    <Adesao />
                                </Grid>
                                <Grid>
                                    <Acesso />
                                </Grid>
                            </>
                            :
                            <Grid>
                                <TarefaContainer />
                            </Grid>

                        }


                    </Grid>


                </Container>

                :
                ''}
            {usuario && usuario.perfil === 'RESPONSAVEL' ?
                <Grid container direction='row' spacing={3}>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6
                        }}>
                        <div className={classes.componentExternal}>
                            <MuralUsuarioContainer />
                        </div>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6
                        }}>
                        <AlunoResponsavelAtivo />
                    </Grid>
                </Grid> :
                ''}
        </div>
    );
}